"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBSearchAutocompleteComponent = void 0;
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
const account_service_1 = require("../services/account.service");
class CSBBSearchAutocompleteComponent {
    constructor(config, accountService) {
        this.accountService = accountService;
        this.filterSubId = new core_1.EventEmitter();
        this.search = (text$) => text$.pipe(operators_1.debounceTime(200), operators_1.distinctUntilChanged(), operators_1.map((term) => {
            const tempVar = term;
            if (!_.isEmpty(term)) {
                term = term.replace(/\(|\)|-| /g, '');
                // handle the scenario when dashes are present in Name field
                // const intValue = parseInt(term, 10);
                // if (isNaN(intValue)) {
                //     term = tempVar;
                // }
            }
            this.searchResultLength = this.filterData(term, ['mobileNumber', 'subscriberBusinessName', 'esnMeid', 'subscriptionId', 'esn']);
            return tempVar.length <= 1 ? [] : this.filterData(term, ['mobileNumber', 'subscriberBusinessName', 'esnMeid', 'subscriptionId', 'esn']);
        }));
        this.formatter = (x) => this.model;
        // customize default values of typeaheads used by this component tree
        config.showHint = true;
    }
    ngOnInit() {
        this.MEID_HEX = 14;
        this.MEID_HEX_W_CD = 15;
        this.MEID_DEC = 18;
        this.MEID_DEC_W_CD = 19;
        if (this.searchInput && this.searchInput.nativeElement) {
            this.searchInput.nativeElement.placeholder = 'Search by Mobile #';
        }
        this.accountService.emitWSDLLoadStatus$.subscribe((accountInfoStatus) => {
            if (accountInfoStatus === 'true') {
                this.searchInput.nativeElement.placeholder = 'Search by Mobile #, Name, Asset #, Serial #, or IMEI';
            }
        });
    }
    filterData(inputData, field) {
        if (inputData.length === this.MEID_HEX_W_CD) {
            inputData = this.removeCheckDigit(inputData, this.MEID_HEX);
        }
        else if (inputData.length === this.MEID_DEC_W_CD) {
            inputData = this.removeCheckDigit(inputData, this.MEID_DEC);
        }
        return this.subDetails.filter(((v) => ((('' + v[field[0]]).toLowerCase().includes(inputData.toLocaleLowerCase())) ||
            (('' + this.removeSpecialCharacters(v[field[1]])).toLowerCase().includes(inputData.toLocaleLowerCase())) ||
            (('' + v[field[2]]).toLowerCase().includes(inputData.toLocaleLowerCase())) ||
            (('' + v[field[3]]).toLowerCase().includes(inputData.toLocaleLowerCase())) ||
            (('' + v[field[4]]).toLowerCase().includes(inputData.toLocaleLowerCase())))));
    }
    removeSpecialCharacters(searchTextQuery) {
        if (searchTextQuery !== undefined) {
            searchTextQuery = searchTextQuery.replace(/\(|\)|-| /g, '');
            return searchTextQuery;
        }
    }
    getFilterSub(subdata) {
        if (subdata != null) {
            this.inputText = subdata;
            if (subdata.hasOwnProperty('subscriptionId')) {
                this.filterSubId.emit(subdata);
            }
        }
    }
    getSearchResult(data) {
        if (this.searchResultLength[0] !== undefined && this.searchResultLength[0] !== null) {
            this.searchSubscription = this.searchResultLength[0];
            this.inputText = this.searchSubscription;
            if (this.searchSubscription.hasOwnProperty('subscriptionId')) {
                this.filterSubId.emit(this.searchSubscription);
            }
        }
        else {
            if (this.validateAppleSerialNo(data)) {
                this.accountService.getDeviceInfo('vendorSerialNumber', data).subscribe((response) => {
                    if (response) {
                        if (response.subscriptionInfoList && response.subscriptionInfoList.length > 0) {
                            const subscription = this.filterData(response.subscriptionInfoList[0].subscriptionId, ['subscriptionId']);
                            if (subscription && subscription.length > 0 && subscription[0].hasOwnProperty('subscriptionId')) {
                                this.filterSubId.emit(subscription[0]);
                            }
                        }
                    }
                });
            }
        }
    }
    resetsearch() {
        this.model = null;
    }
    test(result) {
        this.searchResultLength = result.length;
    }
    removeCheckDigit(inputData, inputLength) {
        return inputData.substring(0, inputLength);
    }
    seeAll() {
        location.href = '/my_account/personal/#/business/device';
    }
    validateAppleSerialNo(serialNo) {
        if (serialNo) {
            const pattern = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$');
            return (serialNo.length === 12 && pattern.test(serialNo));
        }
        return false;
    }
}
exports.CSBBSearchAutocompleteComponent = CSBBSearchAutocompleteComponent;
//# sourceMappingURL=search-autocomplete.component.js.map